export default __webpack_public_path__ + "static/media/League.6500185c.svg";